import { Button, ButtonGroup, Position } from "@blueprintjs/core"
import { MouseEvent, useMemo, useState } from "react"
import { __ } from "src/libs/utilities"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import MeatCard from "./MeatCard"
import { BUNCH } from "src/modules/pe-landing-module/data/interfaces"

/* Protopia Ecosystem component */
export interface IMeatSelectorListProps {
   onClick: ( evt: MouseEvent, id: string, n: number,) => void
   className?: string
   textClassName?: string
   position?: Position 
   onOpen?: () => void
}
const MeatSelectorList = (props: IMeatSelectorListProps): JSX.Element => {
    const [isDop, setIsDop] = useState<Boolean>(false)
    const [currentKey, setCurrentKey] = useState<number>( -1 )
    const butches = useMemo<any[]>(() => {
        const items =  Object.values( BUNCH ).map( key => {
            return {
                title: __( key ),
                components: Object.keys( components() )
                    .filter( ( c: any ) => {
                        return components()[c].bunch === key 
                    })
                    .map( ( c: any ) => ({
                        ...components()[c],
                        componentName: c,
                    }))
            }
        })
        return items
    }, [])

    const onOpenDop = (evt: MouseEvent, key: number ) => {
        evt.stopPropagation()
        evt.preventDefault()
        // if( !components()[ key ].default?.length ) {
        //     props.onClick(evt, key, 0, )
        //     return 
        // } 
        setIsDop( true )
        setCurrentKey( key )
            
        if(!!props.onOpen) {
            props.onOpen()
        }
    }
    return <div className="f-flex">
        <div>
            <div className={`${ props.textClassName  || "small"}  p-2 text-contrast letter-spacing-1 bg-plain`}>
                {__("Append Meat")}
            </div>
            <div className="d-flex">
                <div className={`pe-floats-selector-list overflow-y-auto ${ props.className || "" }`}>
                    <div className="float-list">
                        <ButtonGroup fill vertical> 
                            {/* {
                                Object.keys( components() )
                                .filter( key => !!components()[key].c )
                                .map( key => {
                                    return <Button 
                                        variant="minimal" 
                                        className={`btn-stretch hover p-0 ${ isDop && currentKey === key  ? "bg-black" : "" }`} 
                                        key={key} 
                                        onClick={ (evt: MouseEvent) => onOpenDop( evt, key ) }  
                                    >
                                        <div className={`d-flex w-100 align-items-center py-2 px-3 bg-transparent `}> 
                                            <img
                                                src={ components()[ key ].icon }
                                                alt=""
                                                className="icon mr-1 no-select"
                                                height={12}
                                            />
                                            <div className={`d-flex text-light w-100 flex-grow-100 no-select`}>
                                                <div className={` ${ props.textClassName  || "smaller"} `}>
                                                    { __(components()[ key ].title) }
                                                </div>
                                            </div>
                                            {
                                                components()[ key ].default?.length > 0 && 
                                                <i className={`fas fa-angle-double-right text-light`} />
                                            }    
                                        </div>
                                        
                                    </Button>
                                } )
                            } */}
                            {
                                butches.map( (key, i) => {
                                    return <Button 
                                        variant="minimal" 
                                        className={`btn-stretch hover p-0 ${ currentKey === i  ? "bg-dark" : "" }`} 
                                        key={i} 
                                        onClick={ (evt: MouseEvent) => onOpenDop( evt, i ) }  
                                    >
                                        <div className={`d-flex w-100 align-items-center py-2 px-3 bg-transparent `}> 
                                            <div className={`d-flex text-light w-100 flex-grow-100 no-select`}>
                                                <div className={` ${ props.textClassName  || "smaller"} py-2`}>
                                                    { key.title }
                                                </div>
                                            </div>
                                            <i className={`fas fa-angle-double-right text-light`} />
                                        </div>
                                    </Button>
                                })
                            }
                            
                        </ButtonGroup>
                    </div>
                </div>
                <div className={`pe-floats-selector-list overflow-y-auto ${ isDop ? "opened": "closed"}  ${ props.className || "" }`}>
                    <div className="float-list pb-5"> 
                        {/* {
                            components()[ currentKey ] && 
                            components()[ currentKey ].default && 
                            components()[ currentKey ].default.map((item: any, i: number) => {
                                return <MeatCard key={i} name={ currentKey } i={i} onClick={ props.onClick }/>
                            })
                        }*/} 
                        {
                            butches[ currentKey ]?.components?.map( (component: any) => { 
                                return !!component.default
                                    ?
                                    component.default.map((item: any, i: number) => {
                                        // return <div key={i}>{ component.componentName + i}</div>
                                        return <MeatCard key={ component.componentName + i} name={ component.componentName } i={i} onClick={ props.onClick }/>
                                    })
                                    :
                                    <></>
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
    

}
export default MeatSelectorList